import {
  GetBasicPrintTableData,
  msgTips,
  UpdateBasicBasicCompanyPrintTable,
} from "@/api/user";
import XLSX from "xlsx";
import XLSXStyle from "xlsx-style";
import FileSaver from "file-saver";
export default {
  data() {
    return {
      wsMerge: [],
      OrderData: null,
      PrintData: {
        TableKey: "",
        DetailTableKey: "",
        TableName: "",
        FieldContent: "",
      },
      SheetData: {
        minrow: 0,
        maxrow: 0,
        name: "",
        celldata: [],
      },
      langs: {
        zh_CN: 1,
        zh_TW: 2,
        en: 3,
      },
      langType: 1,
    };
  },
  computed: {
    newmin() {
      return parseInt(this.SheetData.minrow - 1);
    },
    newmax() {
      return parseInt(this.SheetData.maxrow - 1);
    },
  },
  mounted() {
    this.OrderData = { ...this.form, DetailList: this.Notes };
    let lang = localStorage.getItem("locale") || "zh_CN";
    this.langType = this.langs[lang] || 1;
  },
  methods: {
    async getPrintData(TableKey) {
      let res = await GetBasicPrintTableData({
        TableKey,
        LanguageType: this.langType,
      });
      if (res.Code == 0) {
        localStorage.setItem("PrintType", JSON.stringify(true));
        localStorage.setItem("OrderData", JSON.stringify(res.Data[0]));
        this.$router.push("/editsheet");
      }
    },
    async OutPrint(TableKey) {
      let res = await GetBasicPrintTableData({
        TableKey,
        LanguageType: this.langType,
      });
      if (res.Code == 0) {
        this.PrintData = res.Data[0];
        if (this.PrintData.FieldContent) {
          this.SheetData = JSON.parse(this.PrintData.FieldContent);
          let list = JSON.parse(JSON.stringify(this.SheetData.celldata));
          this.getTable(list);
        } else {
          msgTips("暂无模板");
          return;
        }
      } else {
        return;
      }
    },
    async getTable(list) {
      let arr = [];
      const minrow = Math.max(...list.map((obj) => obj.r)) + 1;
      const mincolumn = Math.max(...list.map((obj) => obj.c)) + 1;
      for (let i = 0; i < minrow; i++) {
        arr[i] = [];
        for (let j = 0; j < mincolumn; j++) {
          arr[i][j] = {
            ct: {
              fa: "General",
              t: "g",
            },
            v: {
              v: "",
              m: "",
            },
            r: i,
            c: j,
          };
        }
      }
      this.wsMerge = [];
      let { copylist, cutlist } = await this.getAssetArr(list, arr);
      //   console.log(cutlist);
      let newarr = JSON.parse(JSON.stringify(cutlist));
      console.log(newarr);
      for (let item of copylist) {
        if (item.v.v) {
          if (item.v.v == item.v.m || typeof item.v.v == "number") {
            newarr[item.r][item.c] = item.v.m;
          } else if (item.v.v.toString().includes(".")) {
            newarr[item.r][item.c] = item.v.m;
          } else {
            newarr[item.r][item.c] =
              item.v.v == item.v.m ? item.v.m : this.OrderData[item.v.v];
          }
        } else {
          newarr[item.r][item.c] = "";
        }
        if (item.v.mc) {
          if (item.v.mc.rs != null && item.v.mc.cs != null) {
            this.wsMerge.push({
              s: { r: item.r, c: item.c },
              e: {
                r: parseInt(item.r + item.v.mc.rs - 1),
                c: parseInt(item.c + item.v.mc.cs - 1),
              },
            });
          }
        }
      }
      let ws = XLSX.utils.aoa_to_sheet(newarr);
      ws["!merges"] = this.wsMerge;
      let wb = XLSX.utils.book_new();
      for (let item of copylist) {
        const cellRef = XLSX.utils.encode_cell({ c: item.c, r: item.r });
        const font = this.getFont(item);
        const fill = this.getFill(item);
        const alignment = this.getAlign(item);
        const border = this.getBorder();
        if (ws[cellRef]) {
          ws[cellRef].s = { font, fill, alignment, border };
        }
      }
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      const wbOut = XLSXStyle.write(wb, { bookType: "xlsx", type: "binary" });
      const blob = new Blob([this.s2ab(wbOut)], {
        type: "application/octet-stream",
      });
      //   console.log(blob);
      //   const reader = new FileReader();
      //   reader.onload = function (e) {
      //     const data = e.target.result;
      //     const workbook = XLSX.read(data, {
      //       type: "binary",
      //       cellDates: true,
      //     });
      //     console.log(workbook);
      //     const html = XLSX.utils.sheet_to_html(workbook);
      //     console.log(html);
      //   };
      //   reader.readAsBinaryString(blob);
      const url = URL.createObjectURL(blob);
      //   window.open(url, "_blank");
      let a = document.createElement("a");
      a.href = url;
      a.style.display = "none";
      a.target = "_blank";
      a.download = `${new Date().getTime()}.xlsx`;
      document.body.append(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      //   FileSaver.saveAs(
      //     // Blob: 对象表示一个不可变 原始数据的类文件对象,不一定是JS原生格式的数据。
      //     // File: 基于Blob，继承了blob的功能并将其扩展使其支持用户系统上的文件。
      //     new Blob([this.s2ab(wbOut)], { type: "appliction/octet-stream" }),
      //     // 设置导出的文件名称可随意
      //     `${new Date().getTime()}.xlsx`
      //   );
      // console.log(arr);
      // console.log(newarr);
      // console.log(this.wsMerge);
      // XLSX.writeFile(wb, new Date().getTime() + '.xlsx');
    },
    s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },
    // 获取待循环行所占内容
    async getAssetArr(list, arr) {
      let copylist = JSON.parse(JSON.stringify(list));
      let listrow = 0;
      for (let item of copylist) {
        arr[item.r][item.c] = item;
        listrow = item.r;
      }
      let newarr = JSON.parse(JSON.stringify(arr));
      let endlist = newarr.slice(this.newmax + 1, listrow + 1); //获取资产后面固定的内容
      let arrs = newarr.slice(this.newmin, this.newmax + 1); //获取需要循环的资产内容
      let cutlist = newarr.slice(0, this.newmin); //获取资产前面固定的内容
      //   console.log(endlist);
      let res = await this.getCyleData(arrs);
      if (!res) return { copylist, cutlist };
      let rownum = res.rownum;
      let relist = res.relist;
      cutlist = [...cutlist, ...res.cutlist];
      return new Promise((resolve, reject) => {
        let subnum = rownum - arrs.length;
        let strlistend = [];
        for (let item of endlist) {
          let strlistcontent = [];
          for (let e of item) {
            if (typeof e !== "string") {
              e.r += subnum;
              strlistcontent.push(e);
            } else {
              strlistcontent.push("");
            }
          }
          strlistend.push(strlistcontent);
        }
        cutlist = [...cutlist, ...strlistend];
        for (let item of copylist) {
          if (item.r > this.newmax && item.r < listrow + 1) {
            item.r += subnum;
          }
        }
        let start = copylist.filter((val) => val.r < this.newmin);
        let end = copylist.filter((val) => val.r > this.newmax);
        copylist = [...start, ...relist, ...end];
        resolve({ copylist, cutlist });
      });
    },
    getCyleData(arrs) {
      return new Promise((resolve, reject) => {
        let rownum = 0;
        let relist = [];
        let cutlist = [];
        let num = this.newmax - this.newmin + 1; //需遍历的资产的总行数
        for (let i = 0; i < this.OrderData.DetailList.length; i++) {
          let copyarr = JSON.parse(JSON.stringify(arrs));
          let strlist = [];
          for (let item of copyarr) {
            let strlistcontent = [];
            for (let e of item) {
              if (typeof e !== "string") {
                e.r = parseInt(e.r + num * i);
                if (e.v.v) {
                  e.v.m =
                    e.v.v == e.v.m
                      ? e.v.m
                      : typeof e.v.v != "number" &&
                        e.v.v.toString().includes(".")
                        ? this.OrderData.DetailList[i][e.v.v.split(".")[1]]
                        : e.v.m;
                }
                relist.push(e);
                strlistcontent.push(e.v.m);
              } else {
                strlistcontent.push("");
              }
            }
            strlist.push(strlistcontent);
          }
          rownum += copyarr.length;
          cutlist = [...cutlist, ...strlist];
        }
        resolve({
          rownum,
          relist,
          cutlist,
        });
      });
    },
    //设置单元格字体样式
    getFont(val) {
      let obj = {};
      if (val.v.ff) {
        obj = { ...obj, name: val.v.ff }; //字体类型
      }
      if (val.v.fc) {
        obj = { ...obj, color: { rgb: val.v.fc.replace("#", "") } }; //字体颜色
      }
      if (val.v.fs) {
        obj = { ...obj, sz: val.v.fs }; //字体大小
      } else {
        obj = { ...obj, sz: 10 }; //字体大小
      }
      if (val.v.bl) {
        obj = { ...obj, bold: true }; //字体加粗
      }
      if (val.v.it) {
        obj = { ...obj, italic: true }; //斜体
      }
      if (val.v.cl) {
        obj = { ...obj, strike: true }; //删除线
      }
      if (val.v.un) {
        obj = { ...obj, underline: true }; //下划线
      }
      return obj == {} ? null : obj;
    },
    // 获取对齐方式
    getAlign(val) {
      let obj = {};
      if (val.v.ht != null && val.v.ht == 0) {
        obj = { ...obj, horizontal: "center" }; //水平居中
      }
      if (val.v.ht == 1) {
        obj = { ...obj, horizontal: "left" }; //左对齐
      }
      if (val.v.ht == 2) {
        obj = { ...obj, horizontal: "right" }; //右对齐
      }
      if (val.v.vt == 1) {
        obj = { ...obj, vertical: "top" }; //上对齐
      } else if (val.v.vt == 2) {
        obj = { ...obj, vertical: "bottom" }; //下对齐
      } else if (val.v.vt != null && val.v.vt == 0) {
        obj = { ...obj, vertical: "center" }; //垂直居中
      } else {
        obj = { ...obj, vertical: "center" }; //垂直居中
      }
      return obj == {} ? null : obj;
    },
    // 获取背景
    getFill(val) {
      let obj = {};
      if (val.v.bg) {
        if (val.v.bg == "#D9EDFE90") {
          obj = { ...obj, fgColor: { rgb: "FFFFFF" } }; //背景颜色
        } else {
          obj = { ...obj, fgColor: { rgb: val.v.bg.replace("#", "") } }; //背景颜色
        }
      }
      return obj == {} ? null : obj;
    },
    // 设置边框（合并单元格后会有边框消失的问题）
    getBorder() {
      return {
        // top: { style: "thin", color: { rgb: "C3CBDD" } },
        // left: { style: "thin", color: { rgb: "C3CBDD" } },
        // bottom: { style: "thin", color: { rgb: "C3CBDD" } },
        // right: { style: "thin", color: { rgb: "C3CBDD" } },
        top: { style: "thin", color: { rgb: "000000" } },
        left: { style: "thin", color: { rgb: "000000" } },
        bottom: { style: "thin", color: { rgb: "000000" } },
        right: { style: "thin", color: { rgb: "000000" } },
      };
    },
  },
};
